import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "animated-bg",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"grid-layer\" data-v-252a9e1e></div><div class=\"orb orb-1\" data-v-252a9e1e></div><div class=\"orb orb-2\" data-v-252a9e1e></div><div class=\"orb orb-3\" data-v-252a9e1e></div><div class=\"orb orb-4\" data-v-252a9e1e></div><div class=\"orb orb-5\" data-v-252a9e1e></div><div class=\"orb orb-6\" data-v-252a9e1e></div><div class=\"orb orb-7\" data-v-252a9e1e></div><div class=\"grain-layer\" data-v-252a9e1e></div>", 9)
  ])))
}